<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.component("v-select", vSelect);

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Información del producto",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    DatePicker,
    PageHeader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      datos: [],
      totalArticulos:0,
      search:'',
      arrayPro:[],
      fecha_inicial: "",
      rangode_fecha:"",
      corte:null,
      arraycorte: [],
      arraycortes: [],
      fecha_final:"",
      reporteya:false,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      historialpre: [],
      fields: [
        {
          name: "stock.producto.nombre_producto",
          sortField: "stock.producto.nombre_producto",
          title: "Producto",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "descripcion",
          sortField: "descripcion",
          title: "Descripcion",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "habia",
          sortField: "habia",
          title: "Habia",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "hay",
          sortField: "hay",
          title: "Existente",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "movimiento",
          sortField: "movimiento",
          title: "Tipo",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "10%",
        },
        {
          name: "usuarios",
          sortField: "usuarios",
          title: "Usuario",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "fecha_horas",
          sortField: "fecha_horas",
          title: "Fecha",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
          tr:" padding: 0 !important; margin: 0 !important;",
          th:" padding: 0 !important; margin: 0 !important;",
          td:" padding: 0 !important; margin: 0 !important;",
        },
      },
      formget: {
        nombrep: "",
        companiap: "",
        nit: "C/F",
        direccionp: "",
        statep: true,
      },

      updating: false,
      title: "IMPRIMIR",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],

      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    resetV(){
        this.arrayPro=[];
        this.search='';
        this.reporteya=false;
        this.rangode_fecha="";
        this.totalArticulos=0;
        this.fecha_inicial= "";
      this.corte=null;
      this.arraycorte= [];
      this.arraycortes= [];
      this.fecha_final="";
    },
    async usuariosL() {
        this.arraycortes = [];
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL + "users/get_usuarios",
            {
              headers: {"x-token": this.userT.token},
            }
        );
        this.arraycortes = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    separarfechas(){
      this.fecha_inicial=this.rangode_fecha[0]
      this.fecha_final=this.rangode_fecha[1]
    },
    async selectcorte(valor) {
      this.arraycorte = [];
      for (var i = 0; i < this.arraycortes.length; i++) {
        const estado = this.arraycortes[i].usuario
            .toLowerCase()
            .includes(valor.toLowerCase());
        if (estado === true) {
          this.arraycorte.push(this.arraycortes[i]);
        } else {
          // console.log("nada")
        }
      }
    },
    async changeTypeDates(){
      await this.separarfechas()
    },
    onFiltered(escrito) {
     let idstockm = escrito.toLowerCase();
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/nuevo_get?departamento=0&estante=0&criterio=producto&order=desc&page=1&limite=500&search=" +
            idstockm,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          
          this.arrayPro=response.data.data;
          // console.log(this.historialpre)
          /*  this.formget.nombre=response.data.cabecera.nombre_auto;
       this.formget.state=response.data.cabecera.estado_auto; */
        });
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    generar(){
    this.reporteya=true;
    this.cardex();
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    selected(){
       //console.log(this.search.stockId)
    },
    //Detalle Historial
    cardex() {
        let idstockf=this.search?this.search.stockId:'';
      axios
        .get(
          process.env.VUE_APP_URL +
            "reportes/repoteMov?fecha_inicial=" +
            this.customFormatter(this.fecha_inicial)+
            "&fecha_final=" +
            this.customFormatter(this.fecha_final)+
            "&idstock=" +
            idstockf,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.historialpre = response.data.data;
          this.totalArticulos=response.data.total;
          // console.log(this.historialpre)
          /*  this.formget.nombre=response.data.cabecera.nombre_auto;
       this.formget.state=response.data.cabecera.estado_auto; */
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout v-if="reporteya==true">
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <div class="row mt-4">
      <div class="col d-print-none">
        <b-button
                @click="resetV"
                class="ms-1"
                ><i  class="mdi mdi-arrow-left me-1"></i>REGRESAR</b-button
              >
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
              ref="buttonImprimir"
              href="javascript:window.print()"
              class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>

        <div class="card" id="watermark">
          <div class="card-body">
            <div class="row">
                <div class="col-3"></div>
                <div class="col-6">
              <img
                  class="img-fluid float-right grises"
                  src="../../../../../src/assets/images/logoZonaR.png"
                  alt="Logo"
              />
            </div>
            </div>
            <br/>
            <div class="row" align="center">
              <div class="col" align="center">
                <h2 style="font-weight: bold;">Movimiento de productos</h2>
              </div>
            </div>
            <div class="row" align="center">
              <div class="col" align="left">
                <h5>Cantidad de productos:</h5>
              </div>
              <div class="col" align="left">
                <h5>{{ totalArticulos }}</h5> 
              </div>
              <div class="col" align="left">
               <h5>{{ showHour(new Date()) }} </h5>
              </div>
            </div>
            <!-- Table -->
            <table class="table table-sm table-bordered table-striped">
               
               <tr style=" padding: 0 !important; margin: 0 !important;">
                   <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Producto</h5></th>
                 <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Descripcion</h5></th>
                 <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Habia</h5></th>
                 <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Existente</h5></th>
                 <th style=" padding: 0 !important; margin: 0 !important;">
                   <h5 style="font-weight: bold;">Tipo</h5>
                 </th>
                 <th style=" padding: 0 !important; margin: 0 !important;">
                   <h5 style="font-weight: bold;">Precio compra</h5>
                 </th>
                 <th style=" padding: 0 !important; margin: 0 !important;">
                   <h5 style="font-weight: bold;">Precio venta</h5>
                 </th>
                 <th style=" padding: 0 !important; margin: 0 !important;">
                   <h5 style="font-weight: bold;">Usuario</h5>
                 </th>
                 <th style=" padding: 0 !important; margin: 0 !important;">
                   <h5 style="font-weight: bold;">Fecha</h5>
                 </th>
               </tr>
             
               <tbody>
               <tr v-for="(item, idx) in historialpre" v-bind:key="idx" style=" padding: 0 !important; margin: 0 !important;">
                 
                   <td style=" padding: 0 !important; margin: 0 !important;">
                   <h6>
                     {{ item.stock.producto.nombre_producto  }}
                   </h6>
                 </td> 
                  <td style=" padding: 0 !important; margin: 0 !important;">
                   <h6>
                     {{ item.descripcion }}
                   </h6>
                 </td>
                 <td style=" padding: 0 !important; margin: 0 !important;">
                   <h6>
                     {{item.habia  }}
                   </h6>
                 </td>
                 <td style=" padding: 0 !important; margin: 0 !important;">
                   <h6>
                     {{item.hay  }}
                   </h6>
                 </td>
                 <td style=" padding: 0 !important; margin: 0 !important;">
                   <h6>
                     {{item.movimiento  }}
                   </h6>
                 </td>
                 <td style=" padding: 0 !important; margin: 0 !important;">
                   <h6 align="right">
                     {{money(item.stock.precio_compra_stock?item.stock.precio_compra_stock:0.00)  }}
                   </h6>
                 </td>
                 <td style=" padding: 0 !important; margin: 0 !important;">
                   <h6 align="right">
                     {{money(item.stock.precio_venta_stock?item.stock.precio_venta_stock:0.00)  }}
                   </h6>
                 </td>
                 <td style=" padding: 0 !important; margin: 0 !important;">
                   <h6 align="right">
                     {{ item.user.empleado.persona.nombre_persona +' '+ item.user.empleado.persona.apellido_persona }}
                   </h6>
                 </td>
                 <td style=" padding: 0 !important; margin: 0 !important;">
                   <h6 align="right">
                     {{showHour(item.fecha_hora)  }}
                   </h6>
                 </td>
               </tr>
               </tbody>
             </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
  <Layout v-else>
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark"> 
          <div class="card-body">
            <br/>
            <div class="row" align="center">
              <div class="col" align="left">
                <h2>Movimiento de productos</h2>
              </div>
            </div>
            <div  class="row" align="center">
                <div class="col" align="left">
                    <form>
            <!-- Descripcion -->
            <div class="col-12">
              <div class="">
                <div class="row">
                <label for="phone">Seleccine el rango de fechas</label>
                </div>
                <div class="row">
                <label class="d-inline-flex align-items-center">
                    <date-picker style="max-width: 230px;" v-model="rangode_fecha" range append-to-body lang="en" confirm confirm-text="Aceptar"  @input="changeTypeDates()"></date-picker>
                </label>   
                </div>      
                <div class="row">
                <label for="phone">Seleccine el producto a buscar</label>
                </div>
                <div class="row">
                <label class="d-inline-flex align-items-center">
                    <v-select
                    style="min-width: 230px;"
                    @input="selected()"
                    @search="onFiltered"
                    placeholder="Buscar..."
                    v-model="search" :options="arrayPro"
                    item-value="stockId"
                    :getOptionLabel="prod => prod.Stock.producto.nombre_producto+' | '+prod.Stock.codigo_stock"
                ></v-select>
                </label>   
                </div>   
              </div>
              
            </div>
            <!-- Botones -->
            <div class="text-end pt-5 mt-3">
              <b-button
                @click="generar"
                variant="success"
                class="ms-1"
                >Generar Reporte</b-button
              >
            </div>
          </form>    
            </div>
        </div>
        </div>
    </div>
    </div>
    </div>
  </Layout>
</template>
<style>
.grises {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}

@media print {
  @page {
    margin: 0;
    size: auto;
  }
}</style>
